/**
 * A deal view id as it arrives from a route param. Valid ids are positive integers, so
 * anything else — missing, non-numeric, a repeated query param, zero, negative or
 * fractional — resolves to null and lets the caller branch once.
 */
export const parseDealViewId = (value: unknown): number | null => {
  if (typeof value !== 'string' && typeof value !== 'number') {
    return null;
  }

  const viewId = Number(value);

  return Number.isInteger(viewId) && viewId > 0 ? viewId : null;
};
